import { create } from 'zustand';

/**
 * Branding global do produto (AB#61 — REQ-012 Seção 2).
 *
 * Carregado uma vez no boot do App.tsx via GET público `/system-settings/public`
 * (sem auth). Quando o Super Admin edita `app_nome`/`app_url` no painel
 * `/admin/system-settings`, o efeito vale para próximos carregamentos —
 * em tempo de execução a atualização chega via `recarregar()` se chamado.
 *
 * Fallback: se o fetch falhar (backend fora, primeira instalação) ou a chave
 * vier vazia, usamos a env var VITE_APP_NOME e, por último, `'Vinya'` — o nome
 * do produto (AB#186). Evita o flash de "[Nome do produto]" no boot antes do
 * GET de branding resolver.
 */

interface BrandingState {
  app_nome: string;
  app_url: string;
  suporte_whatsapp: string;
  /**
   * [AB#467] Dias de antecedência do aviso de reajuste anual. Chega como
   * STRING (todo SystemSettings é texto) — quem consome converte com
   * `Number(...) || 30`. Vem vazio quando o backend está fora ou a chave não
   * foi seedada.
   */
  dias_aviso_reajuste_anual: string;
  carregado: boolean;
  recarregar: () => Promise<void>;
}

const FALLBACK_NOME = import.meta.env.VITE_APP_NOME ?? 'Vinya';
const API_URL = `${import.meta.env.VITE_API_URL ?? 'http://localhost:8000'}/api`;

export const useBrandingStore = create<BrandingState>((set) => ({
  app_nome: FALLBACK_NOME,
  app_url: '',
  suporte_whatsapp: '',
  dias_aviso_reajuste_anual: '',
  carregado: false,
  recarregar: async () => {
    try {
      const res = await fetch(`${API_URL}/system-settings/public`);
      if (!res.ok) return;
      const data = (await res.json()) as Partial<
        Pick<
          BrandingState,
          'app_nome' | 'app_url' | 'suporte_whatsapp' | 'dias_aviso_reajuste_anual'
        >
      >;
      set({
        // Mantém o placeholder se a chave vier vazia (seed inicial).
        app_nome: data.app_nome?.trim() ? data.app_nome : FALLBACK_NOME,
        app_url: data.app_url ?? '',
        suporte_whatsapp: data.suporte_whatsapp ?? '',
        dias_aviso_reajuste_anual: data.dias_aviso_reajuste_anual ?? '',
        carregado: true,
      });
    } catch {
      // Backend fora — segue com fallback hardcoded.
    }
  },
}));
